import React from 'react';

import { MobileSwiper, MobileSwiperProps } from '../../MobileSwiper';
import { cn } from '../../../lib/css/className/className';
import './AlertSwiper.css';

const cls = cn('AlertSwiper');

type AlertSwiperProps = Pick<MobileSwiperProps, 'indicatorColor' | 'items' | 'onSelectedItemChange' | 'data-testid'>;

export const AlertSwiper = function AlertSwiper(props: AlertSwiperProps) {
    const { items, indicatorColor, onSelectedItemChange, 'data-testid': dataTestId = 'AlertSwiper' } = props;

    return (
        <MobileSwiper
            data-testid={dataTestId}
            indicatorClassName={cls('')}
            indicatorColor={indicatorColor}
            onSelectedItemChange={onSelectedItemChange}
            items={items}
        />
    );
};
